export enum ChainId {
  Ethereum = 1,
  Sepolia = 11155111,
}
